<template>
  <v-card>
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>add</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Coordinator Details</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <div v-for="prop in clientProps">
      <strong>{{ prop.title }}</strong><br>
      <p>{{ item[prop.key] }}</p>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      clientProps: [
        {title: "Name", key: 'name'},
        {title: "Mobile", key: 'mobile'},
        {title: "Commission %", key: 'commission_percent'},
        {title: "Email", key: 'email'},
        {title: "Address", key: 'address'},
        {title: "Notes", key: 'notes'},
      ]
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    }    
  },
  mounted() {},
  created() {
  },
};
</script>
